import { ChevronDownIcon } from 'lucide-react'
import { Button } from 'twyne-new.ui'

export default function QuickActionsButton() {
  return <Button size='lg' variant='outline' className='max-md:p-2.5'>
    <span className='hidden md:inline'>Quick Actions</span>
    <ChevronDownIcon size={16} />
  </Button>
}
